import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UserProvider, useUser } from "@/context/UserContext";
import { CourseProvider } from "@/context/CourseContext";
import NameCapture from "@/pages/NameCapture";
import Home from "@/pages/Home";
import ModuleReader from "@/pages/ModuleReader";


function RequireUser({ children }) {
  const { user, loading } = useUser();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<NameCapture />} />
      <Route
        path="/home"
        element={
          <RequireUser>
            <Home />
          </RequireUser>
        }
      />
      <Route
        path="/module/:id"
        element={
          <RequireUser>
            <ModuleReader />
          </RequireUser>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <CourseProvider>
          <AppRoutes />
        </CourseProvider>
      </UserProvider>
    </BrowserRouter>
  );
}
